module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    config: {
        resourceConnected: false,
        filterContext: undefined, // in case multiple filterForms are used this filterContext-string tells how the parent key is named within the filter object sent to the server.
    },

    methods: {
        onChange(){
            this.triggerClosest('updateFilters', {
                filterContext:  this.config.filterContext,
                params:         ((this.model.dirtyFields || {}).data || {}).attributes || {}
            })
        }
    },
}